import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { isDev } from "@/lib/ambito";
import { useAuth } from "@/contexts/AuthContext";
import { useConfirm } from "@/components/ConfirmProvider";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { errore } from "./crmComuni";

// Sprint CRM-2B — selezione delle righe e azioni in blocco; le cambiate da altri nel frattempo si saltano
export default function AzioniBlocco({ items, pipelineId, crmMe, onFatto, children }) {
  const { user } = useAuth() || {};
  const confirm = useConfirm();
  const [ids, setIds] = useState([]);
  const [utenti, setUtenti] = useState([]);
  const [tit, setTit] = useState("");
  useEffect(() => { setIds((x) => x.filter((id) => items.some((o) => o.id === id))); }, [items]);
  const tutte = items.length > 0 && ids.length === items.length;
  const sel = { ids, tutte, tog: (id) => setIds((x) => (x.includes(id) ? x.filter((y) => y !== id) : [...x, id])),
    togliTutte: () => setIds(tutte ? [] : items.map((o) => o.id)) };
  const puoTitolare = isDev(user) || crmMe?.livelli?.[pipelineId] === "tutte";
  useEffect(() => {
    if (!ids.length || !puoTitolare) return;
    api.get(`/crm/opportunita/${ids[0]}/utenti-idonei`).then((r) => setUtenti(r.data)).catch(() => setUtenti([]));
  }, [ids, puoTitolare]);
  const originali = () => Object.fromEntries(items.filter((o) => ids.includes(o.id)).map((o) => [o.id, o.updated_at]));
  const esegui = async (body) => {
    try {
      const r = await api.post("/crm/opportunita/blocco", { ...body, originali: originali() });
      toast.success(r.data.messaggio); setIds([]); onFatto();
    } catch (e) { toast.error(errore(e)); }
  };
  const abbandona = async () => {
    if (await confirm({ title: "Segna abbandonate", message: `Segnare abbandonate ${ids.length} opportunità?`, confirmLabel: "SI, segna" })) esegui({ azione: "abbandona" });
  };
  return (
    <div className="space-y-2">
      {!!ids.length && (
        <div className="flex flex-wrap items-center gap-2 rounded bg-sky-50 border border-sky-200 px-3 py-2 text-sm" data-testid="crm-blocco-barra">
          <span data-testid="crm-blocco-n">{ids.length} selezionate</span>
          <Button size="sm" variant="outline" onClick={abbandona} data-testid="crm-blocco-abbandona">Segna abbandonate</Button>
          {puoTitolare && <>
            <Select value={tit} onValueChange={setTit}>
              <SelectTrigger className="w-48 h-8" data-testid="crm-blocco-titolare"><SelectValue placeholder="Nuovo titolare" /></SelectTrigger>
              <SelectContent>{utenti.map((u) => <SelectItem key={u.id} value={u.id}>{u.nome}</SelectItem>)}</SelectContent>
            </Select>
            <Button size="sm" variant="outline" disabled={!tit} onClick={() => esegui({ azione: "titolare", titolare_id: tit })} data-testid="crm-blocco-cambia-titolare">Cambia titolare</Button>
          </>}
        </div>
      )}
      {children(sel)}
    </div>
  );
}
